'use client';

import {
  GRENADE_DAMAGE, GRENADE_VS_STANCE, SMOKE_SHIELD_ROUNDS, SMOKE_MIT,
  FLASH_BLIND_ROUNDS, MEDKIT_HEAL_FRAC, MEDKIT_HEAL_FLOOR, KNIFE,
} from '@cs-shot/battle-sim';
import { useLocalTranslation } from '../../../hooks/useLocalTranslation';
import translations from './RushMid.translations';

export type GearInfoKey = 'frag' | 'smoke' | 'flash' | 'medkit' | 'knife';

/**
 * Числовая сводка по снаряжению — все параметры из констант battle-sim, без
 * хардкода. Один источник для {@link GearInfoSheet} (закуп) и правил на экране
 * списка игр ({@link HowToPlayContent}). Строки несут `[[stance|Слово]]`-токены
 * — рендерь через `StanceText`.
 */
export const useGearInfo = (): Record<GearInfoKey, string> => {
  const { t } = useLocalTranslation(translations);
  // потолок прямого попадания гранаты: база × верхний скаттер (0.8) × множитель Защиты
  const fragMax = Math.round(GRENADE_DAMAGE * 0.8 * GRENADE_VS_STANCE.defense);
  return {
    frag: t('gearFragInfo', { max: fragMax }),
    smoke: t('gearSmokeInfo', { rounds: SMOKE_SHIELD_ROUNDS, mit: Math.round((1 - SMOKE_MIT) * 100) }),
    flash: t('gearFlashInfo', { rounds: FLASH_BLIND_ROUNDS }),
    medkit: t('gearMedkitInfo', { frac: Math.round(MEDKIT_HEAL_FRAC * 100), floor: MEDKIT_HEAL_FLOOR }),
    knife: t('gearKnifeInfo', { dmg: KNIFE.damage, weak: KNIFE.weak }),
  };
};
